<script setup lang="ts">
import VDropdownMenu from '@components/dropdowns/VDropdownMenu/VDropdownMenu.vue';

import type { TheLanguageSelectorProps } from './types';
import { useTheLanguageSelector } from './composables';

withDefaults(defineProps<TheLanguageSelectorProps>(), {});

const {
  currentLocale,
  setLocale,
  interfaceLanguages,
} = useTheLanguageSelector();
</script>

<template>
  <VDropdownMenu v-data-qa-auto-id="'TheLanguageSelector'"
    zero-min-width
    name="locale"
    :options="interfaceLanguages"
    :value="currentLocale"
    :style-type="isDark ? 'dark' : 'light'"
    :left-icon="isMobileMenu ? 'pi-language' : undefined"
    hide-chevron
    @change="setLocale"
  />
</template>
